import React from 'react'
import { connect } from 'react-redux'

import { Box, Text, Avatar, VStack, HStack } from '@chakra-ui/react'

import { IconChevronDown } from '_base/Icon/sub/IconChevronDown'

function AccountButton({ display, userEmail, onClick, userType, as, tour }) {
  const Account = userEmail || 'Account'
  return (
    <Box as={as} onClick={onClick} display={display} data-tour={tour}>
      <HStack spacing="2">
        <Avatar size="sm" name={Account} />
        <VStack display={{ base: 'none', md: 'flex' }} alignItems="flex-start" spacing="1px" ml="2">
          <Text maxW="160px" fontSize="sm" isTruncated>
            {Account}
          </Text>
          <Text fontSize="xs" color="brand.muted">
            {userType}
          </Text>
        </VStack>
        <IconChevronDown display={{ base: 'none', md: 'flex' }} />
      </HStack>
    </Box>
  )
}

const mapStateToProps = state => {
  return {
    userEmail: state.user?.data?.email || null,
    userType: state.user?.data?.type || 'User'
  }
}

export default connect(mapStateToProps)(AccountButton)
